<script lang="ts">
  import { navigate } from '../helpers/Navigation';
  export let to: string;

  function follow(event: MouseEvent) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    navigate(to);
  }
</script>

<a href={to} on:click={follow}><slot /></a>
